import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { clientAssessmentActions } from '../../../../../store';

function useEditAssessment(assessmentId: number | undefined) {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [showConfirmEditDialog, setShowConfirmEditDialog] = useState(false);

  const handleEditAssessment = useCallback(async () => {
    if (!assessmentId) return;
    setShowConfirmEditDialog(false);

    const { error } = await dispatch(
      clientAssessmentActions.editAssessmentNote({
        assessmentNoteId: assessmentId,
        getAccessTokenSilently,
      }),
    );

    if (error) return;

    dispatch(
      clientAssessmentActions.getAssessmentNote({
        assessmentNoteId: assessmentId,
        getAccessTokenSilently,
      }),
    );
  }, [dispatch, getAccessTokenSilently, assessmentId]);

  return {
    showConfirmEditDialog,
    setShowConfirmEditDialog,
    handleEditAssessment,
  };
}

export default useEditAssessment;
